/*
 * @Author: jiangxd
 * @Date: 2021-06-23 15:39:39
 * @LastEditTime: 2021-08-04 19:00:56
 * @LastEditors: jiangxd
 * @Description:
 * @FilePath: /rs_ips_maintence/src/library/utils/globalElement.ts
 */
/**
 * Created by Qingger Corp.
 * User: jsspf
 * Date: 2017/11/22
 * Time: 14:42
 */
import type { ElMessage } from 'element-ui/types/message';
import type Vue from 'vue';
interface GlobalElement {
  message: ElMessage;
  Vm: Vue;
  installCom?: (...args: any) => void;
}

/**
 * 全局元素对象
 * @type {{message: any}}
 */
export const globalElement: GlobalElement = {
  message: null,
  Vm: null,
};
